import { applyTheme, useTheme, watchDeviceTheme, type Theme } from '../../state/theme'

const CHOICES: { value: Theme; label: string; help: string }[] = [
  { value: 'system', label: 'Match this device', help: 'Dark when this device is dark.' },
  { value: 'light', label: 'Light', help: 'Always light, whatever the phone is set to.' },
  { value: 'dark', label: 'Dark', help: 'Easier on the eyes in a dark room.' },
]

/** How the app is lit on this device (spec §1.5): the phone's own setting, or a choice that overrides it. */
export function AppearanceSection() {
  const theme = useTheme((s) => s.theme)
  const choose = useTheme((s) => s.choose)
  return (
    <section className="screen-section" aria-labelledby="appearance-heading">
      <h3 id="appearance-heading">Appearance</h3>
      <p className="section-description">This choice is kept on this device, like the sound settings.</p>
      <div className="choice-list" role="radiogroup" aria-labelledby="appearance-heading">
        {CHOICES.map((choice) => (
          <label key={choice.value} className={theme === choice.value ? 'choice is-chosen' : 'choice'}>
            <input
              type="radio"
              name="theme"
              value={choice.value}
              checked={theme === choice.value}
              onChange={() => choose(choice.value)}
            />
            <span>
              <strong>{choice.label}</strong>
              <small>{choice.help}</small>
            </span>
          </label>
        ))}
      </div>
    </section>
  )
}

/** Called once as the app starts, before anything is drawn. */
export function startTheme(): void {
  applyTheme(useTheme.getState().theme)
  watchDeviceTheme()
}
